module.exports = __webpack_public_path__ + "static/media/blog-ads-vs-reco-thumb@3x.b8ac2d7c.jpg";